export const IDLE_CHANGED = 'IDLE_CHANGED';

export default {
  namespaced: true,
  state: {
    isIdle: false,
  },
  getters: {
    status: state => state.isIdle,
  },
  mutations: {
    [IDLE_CHANGED](state, payload) {
      state.isIdle = payload;
    },
  },
};
